// src/lib/billingApi.js
import { auth } from '../firebase-config';
import { API_BASE } from './apiBase';

async function authedPost(path, body) {
  const user = auth.currentUser;
  if (!user) throw new Error('Devi effettuare l’accesso.');
  const token = await user.getIdToken();
  const res = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(body || {}),
  });
  if (!res.ok) {
    let detail;
    try { detail = (await res.json()).detail; } catch (e) { /* non-JSON */ }
    const err = new Error(detail || `Errore (${res.status})`);
    const code = res.headers.get('X-Error-Code');
    if (code) err.code = code;
    throw err;
  }
  return res.json();
}

export async function startCheckout(plan, amount, lang) {
  const { url } = await authedPost('/billing/checkout', { plan, amount, lang });
  window.location.assign(url);
}

export async function openPortal() {
  const { url } = await authedPost('/billing/portal', {});
  window.location.assign(url);
}
